import { animationTransition } from '@shared/joykit/packages/core/utils';
import { styled } from '@withjoy/joykit';

export const BurgerIconWrapper = styled.button<{ isActive: boolean }>`
  background-color: ${({ isActive, theme }) => (isActive ? theme.colors.mono3 : theme.colors.transparent)};
  transition: ${animationTransition('background-color')};
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.mono2};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.mono3};
  }
`;

export const PlainButtonWrapper = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent;
`;
